import axios from "axios";
import { toast } from "react-toastify";

let redirectingToLogin = false;

function redirectToLoginOnce(message) {
  if (redirectingToLogin) return;
  if (typeof window !== "undefined" && window.location.pathname === "/login") return;
  redirectingToLogin = true;
  if (message) toast.error(message);
  localStorage.clear();
  setTimeout(() => {
    window.location.href = "/login";
  }, 1500);
}

const setupAxiosInterceptors = () => {
  axios.interceptors.response.use(
    (response) => {
      const code = response?.data?.error_code;
      if (code === 463 || code === 464) {
        if (code === 463) redirectToLoginOnce("Session expired. Redirecting to login...");
        else if (code === 464) redirectToLoginOnce("Account validity expired. Redirecting to login...");
        else if (code === 461) redirectToLoginOnce("Invalid token. Please log in again.");
      }
      return response;
    },
    (error) => {
      const errorCode = error?.response?.data?.error_code;
      if (errorCode === 463) redirectToLoginOnce("Session expired. Redirecting to login...");
      else if (errorCode === 464) redirectToLoginOnce("Account validity expired. Redirecting to login...");
      else console.error(error);
      return Promise.reject(error);
    }
  );
};

export default setupAxiosInterceptors;
